define([
    'jquery',
    './nav_fixed',
    './nav_offcanvas'
], function ($, navFixed, navOffcanvas) {
    'use strict';

    let prevScrollPosition = window.scrollY; // save the current position
    let headerDiv = document.querySelector("header");
    let headerBottom = headerDiv.offsetTop + headerDiv.offsetHeight;

    const tm = require('./vendor/gsap/gsap').TweenMax;
    const Power1 = require('./vendor/gsap/gsap').Power1;
    const Power2 = require('./vendor/gsap/gsap').Power2;
    const Linear = require('./vendor/gsap/gsap').Linear;
    const CSSRulePlugin = require('./vendor/gsap/CSSRulePlugin');

    const FastClick = require('./vendor/fastclick');
    const easing = require('./vendor/jquery.ease');
    const lazyLoad = require('./vendor/lazysizes-umd');

    const his = require('./vendor/jquery.history');
    const History = window.History; // jquery.history.js created object
    let partial_url;

    const HomePage = require('./pages/home.js');
    const HousePage = require('./pages/house');
    const ServicesPage = require('./pages/services');
    const LocationPage = require('./pages/location');
    const GalleryPage = require('./pages/gallery');
    const AreaPage = require('./pages/area');
    const AreaBeachesPage = require('./pages/area_beaches');
    const AreaDiningPage = require('./pages/area_dining');
    const AreaGuidesPage = require('./pages/area_guides');
    const AreaToursPage = require('./pages/area_tours');
    const PrivacyPolicyPage = require('./pages/privacy_policy');
    const AboutPage = require('./pages/about');
    const MediaPage = require('./pages/media');
    const BookPage = require('./pages/book');

    function isNumeric(n) {
        return !isNaN(parseFloat(n) && isFinite(n));
    }

    // function initHeaderHover() {
    //     let $header = $('.masthead');
    //
    //     if ($header.length === 0) {
    //         return;
    //     }
    //
    //     $(document).off('mouseenter', '.masthead');
    //     $(document).off('mouseleave', '.masthead');
    //
    //     $(document)
    //         .on('mouseenter', '.masthead', function (event) {
    //             $('body').addClass('mouseenter');
    //             // tm.to($('.masthead'), 0.4, {width: "180px", ease: Power1.easeOut});
    //         })
    //         .on('mouseleave', '.masthead', function (event) {
    //             $('body').removeClass('mouseenter');
    //             // tm.to($('.masthead'), 0.8, {width: "2px", ease: Power1.easeOut});
    //         });
    // }

    /**
     * Open "external" links in another tab (or window)
     * <a rel='external' ... > ... </a>
     */
    function enableExternalClickHandler() {
        console.log('common.enableExternalClickHandler');

        let $el = $('a[rel*=external]');
        $el.off('click');
        $el.on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            let $button = $(this),
                href = $button.attr('href'),
                noProtocol = href.replace(/http[s]?:\/\//, '');

            // check if Google Analytics tracking code is loaded and initialized
            console.log('window.ga: ', window.ga);
            console.log('window.gtag: ', window.gtag);

            if (typeof gtag === 'function') {
                console.log("Google Analytics 4 is installed on this website.");
                //     // track Google Analytics event
                //     // ga('send', 'event', 'external', 'click', noProtocol, '', {
                //     //     'nonInteraction': true
                //     // });
            } else {
                console.log("Google Analytics 4 is not installed on this website.");
            }

            navFixed.closeOffCanvas();

            // open new tab/window for the clicked link
            setTimeout(function () {
                window.open(href);
            }, 200);
        });
    }

    function initHistoryHandler() {

//         // Should be null because we haven't modified the history stack yet
//         console.log("History.state before pushState: ", history.state);
//
// // Now push something on the stack
//         history.pushState({ name: "Example" }, "pushState example", "page3.html");
//
// // Now state has a value.
//         console.log("History.state after pushState: ", history.state);
//
        let state = History.getState();
        console.log(state);
        console.log('History.state:', state.data, state.url);

        // console.log('window.location', window.location);
        // console.log('window.location.href', window.location.href);
        // console.log('window.location.pathname', window.location.pathname);
        partial_url = window.location.pathname || '';
        console.log('partial_url:', partial_url);


        // History.Adapter.bind(window, 'popstate', function(event) {
        // $(window).off('popstate');
        // $(window).on('popstate', function(event) {
        //     console.log('');
        //     console.log('>> onPopState');
        //     console.log('   event: ', event);
        //
        //     var State = History.getState(); // Note: We are using History.getState() instead of event.state
        //     console.log('   State: ', State);
        //     console.log('   State.data: ', State.data);
        // });

        window.onpopstate = function(event) {
            var message =
                "onpopstate: "+
                "location: " + location.href + ", " +
                "data: " + JSON.stringify(event.state) +
                "\n\n"
            ;

            console.log(message, event);
        };

        window.onhashchange = function(event) {
            var message =
                "onhashchange: "+
                "location: " + location.href + ", "+
                "hash: " + location.hash +
                "\n\n"
            ;

            console.log(message);
        };

        // History.Adapter.bind(window, 'statechange', function () {
        // Note: We are using statechange instead of popstate
        $(window).off('statechange');
        History.Adapter.bind(window, 'statechange', function (event) {
            console.log('');
            console.log('>> onStateChange');
            console.log('   event: ', event);

            let state = History.getState(); // Note: We are using History.getState() instead of event.state
            console.log('   State: ', state);
            console.log('   State.data: ', state.data);

            let data = state.data;







            if (data.load_partial) {
                console.log('   partial_url', partial_url);
                console.log('   data.load_partial', data.load_partial);

                if (data.load_partial === partial_url) {
                    console.log('   Same page. Just scroll to the position');
                    navFixed.onResize();

                    if (data.scroll_to) {
                        scrollToElem(data.scroll_to);

                        // Trigger GA4 page view event
                        trackEventAsync('page_view', {
                            page_location: window.location.href + '#' + data.scroll_to,
                            page_path: partial_url + '#' + data.scroll_to,
                            page_title: document.title
                        });
                    }

                } else {
                    partial_url = data.load_partial;

                    $('body').addClass('loading');

                    allPagesAnimateOut(function () {
                        $.ajax({
                            method: "GET",
                            url: data.load_partial,
                            beforeSend: function (request) {
                                console.log('start loading >>>');
                            },
                            dataType: 'html'
                        })
                            .done(function (markup, textStatus, jqXHR) {
                                let $wrapper = $('.page-row-expanded');
                                let $viewport = $(markup).find('.viewport');
                                const newTitle = $(markup).filter('title').text();

                                let viewportTemplate = $viewport.data('template');
                                console.log('$viewport: ', $viewport);
                                console.log('viewportTemplate: ', viewportTemplate);

                                if (viewportTemplate) {
                                    $('body').removeClassStartingWith('template');
                                    $('body').addClass('template_' + viewportTemplate);
                                }

                                $wrapper.html($viewport);
                                document.title = newTitle;

                                // $wrapper.imagesLoaded(function () {
                                //     navFixed.onResize();
                                // });


                                // Trigger GA4 page view event
                                trackEventAsync('page_view', {
                                    page_location: window.location.href,
                                    page_path: partial_url,
                                    page_title: newTitle
                                });


                                navFixed.onResize();

                                $(document).on('lazyloaded', function () {
                                    navFixed.onResize();
                                });

                                allPagesAnimateIn(function () {
                                    // tm.to($('.masthead'), 0.8, {width: "2px", ease: Power1.easeOut});

                                    $('body').removeClass('loading');

                                    if (data.scroll_to) {
                                        scrollToElem(data.scroll_to)
                                    } else {
                                        scrollToElem(1);
                                    }
                                });
                            })
                            .fail(function (jqXHR, textStatus, errorThrown) {
                                console.error('ajax failed', textStatus);
                            })
                            .always(function (datajqXHR, textStatus, jqXHRerrorThrown) {
                                console.log('<<< loading complete.');
                                // $('body').removeClass('loading');
                                navOffcanvas.close();
                            });
                    });
                }
            }
        });
    }

    function topNavOnClick() {
        $(document).off('touchend click', '.nav__link');
        $(document).on('touchend click', '.nav__link', function (event) {
            event.preventDefault();
            event.stopPropagation();

            // TODO: check if Google Analytics tracking code is loaded and initialized
            // console.log('window.ga: ', window.ga);
            // console.log('window.gtag: ', window.gtag);

            const $link = $(this);
            console.log('$link.href: ', $link.attr('href'));

            const $nav = $('.nav');
            $nav.find('.active').removeClass('active');
            $link.parent().addClass('active');

            let $allSubmenus = $nav.find('.submenu');
            let $mysubmenu = $link.parent().find('.submenu');

            if (!$mysubmenu.is(":visible")) {
                $allSubmenus.slideUp();
                $link.parent().find('.submenu').slideDown();
            }

            if ($mysubmenu.length === 0) {
                navFixed.closeOffCanvas();
            }

            let data = {};
            data.load_partial = $link.attr('href');
            data.title = $link.text();

            History.pushState(data, data.title, $link.attr('href'));
        });

        $(document).off('click', '.submenu__link');
        $(document).on('click', '.submenu__link', function (event) {
            event.preventDefault();
            event.stopPropagation();

            let $link = $(this);

            $('.nav').find('.active').removeClass('active');
            $link.addClass('active');
            var $closest = $link.closest('.nav__item');
            var $parentLink = $closest.find('.nav__link');
            $closest.addClass('active');


            let url;
            let state = {};

            if ($closest.find('.submenu--area').length) {
                state.load_partial = $parentLink.attr('href');
                state.scroll_to = $link.data('filter');
                url = $parentLink.attr('href'); // + '#' + $link.data('filter');
            } else if($closest.find('.submenu--house').length) {
                state.load_partial = $parentLink.attr('href');
                state.scroll_to = $link.data('filter');
                url = $parentLink.attr('href'); // + '#' + $link.data('filter');
            } else {
                state.load_partial = $link.attr('href');
                state.scroll_to = '';
                url = $link.attr('href');
            }

            state.title = $closest.find('.nav__link').text() + ' / ' + $(event.target).text();

            navFixed.closeOffCanvas();

            console.log('.submenu__link state: ', state);

            History.pushState(state, state.title, url);

            if (state.scroll_to) {
                window.location.hash = $link.data('filter');
            }
        });
    }

    function scrollToElem(elementId) {
        let $el = $('#' + elementId);

        if ($el.length) {
            console.log('scrolling...');

            $('html, body').animate({
                scrollTop: ($el.offset().top - 34)
            }, 1200, 'easeInOutQuart');
        } else {
            if (isNumeric(elementId)) {
                $('html, body').animate({
                    scrollTop: elementId - 135
                }, 100, 'easeInOutQuart');
            } else {
                console.error('error scrolling to: ', elementId);
            }
        }
    }

    function allPagesAnimateIn(callback) {
        HomePage.animateIn(callback);
        HousePage.animateIn(callback);
        ServicesPage.animateIn(callback);
        LocationPage.animateIn(callback);
        GalleryPage.animateIn(callback);
        AreaPage.animateIn(callback);
        AreaBeachesPage.animateIn(callback);
        AreaDiningPage.animateIn(callback);
        AreaGuidesPage.animateIn(callback);
        AreaToursPage.animateIn(callback);
        AboutPage.animateIn(callback);
        MediaPage.animateIn(callback);
        BookPage.animateIn(callback);
        PrivacyPolicyPage.animateIn(callback);
    }

    function allPagesAnimateOut(callback) {
        HomePage.animateOut(callback);
        HousePage.animateOut(callback);
        ServicesPage.animateOut(callback);
        LocationPage.animateOut(callback);
        GalleryPage.animateOut(callback);
        AreaPage.animateOut(callback);
        AreaBeachesPage.animateOut(callback);
        AreaDiningPage.animateOut(callback);
        AreaGuidesPage.animateOut(callback);
        AreaToursPage.animateOut(callback);
        AboutPage.animateOut(callback);
        MediaPage.animateOut(callback);
        BookPage.animateOut(callback);
        PrivacyPolicyPage.animateOut(callback);
    }

    function initializeLogoOnClick() {
        $(document).off('click', '.masthead__logo');
        $(document).on('click', '.masthead__logo', function (event) {
            event.preventDefault();

            const $link = $(this);

            const data = {};
            data.load_partial = $link.attr('href');
            data.title = $link.text();

            const $nav = $('.nav');
            $nav.find('.submenu').slideUp();
            $nav.find('.active').removeClass('active');

            navFixed.closeOffCanvas();

            History.pushState(data, data.title, $link.attr('href'));
        });
    }

    var _goTopClick = function () {
        $('.gotop__link').on('click', function (event) {
            event.preventDefault();

            navFixed.closeOffCanvas();

            $('html, body').animate({
                scrollTop: 0
            }, 1200, 'easeInOutQuart');
        });
    };

    function initEventHandlers() {
        console.log('common.initEventHandlers()');

        FastClick.attach(document.body);
        enableExternalClickHandler();
        initHistoryHandler();
        topNavOnClick();
        initializeLogoOnClick();
        // initHeaderHover();
    }

    function extendjQueryWithRemoveClass() {
        $.fn.removeClassStartingWith = function (filter) {
            $(this).removeClass(function (index, className) {
                return (className.match(new RegExp("\\S*" + filter + "\\S*", 'g')) || []).join(' ')
            });

            return this;
        };
    }

    function showHideHeaderOnScroll() {
        window.onscroll = function() {
            var currentScrollPos = window.pageYOffset;

            console.log(window.innerWidth);

            if (window.innerWidth > 768) {
                headerDiv.style.top = "0";
                return;
            }

            /* if we're scrolling up, or we haven't passed the header, show the header */
            if (prevScrollPosition > currentScrollPos || currentScrollPos < headerBottom) {
                headerDiv.style.top = "0";
            } else {
                /* otherwise we're scrolling down & have passed the header so hide it */
                // headerDiv.style.top = "-7.2rem";
                headerDiv.style.top = "-118px";
            }

            prevScrollPosition = currentScrollPos;
        }
    }

    function trackEventAsync(eventName, params) {
        if (typeof gtag === 'function') {
            gtag('event', eventName, params);

            console.log('GA4 ' + eventName + ' tracked for: ', params);
        } else {
            setTimeout(function () {
                trackEventAsync(eventName, params);
            }, 100); // Retry after 100ms
        }
    }

    const init = function () {
        extendjQueryWithRemoveClass();
        showHideHeaderOnScroll();

        $('body').removeClass('fade-out');

        navFixed.init();
        navOffcanvas.init();

        initEventHandlers();

        tm.to($('.masthead'), 2.2, {
            css: {x:0, y:0, opacity: 1}, ease: Power1.easeOut, onComplete: function () {
                tm.to($('.masthead__logo'), 0.8, {css: {x:0, y:0, opacity: 1, scale: 1}});
                tm.to($('.nav'), 0.9, {
                    css: {opacity: 1}, ease: Power1.easeOut, delay: 0.1, onComplete: function() {
                        tm.staggerTo($('.nav__item'), 0.6,
                            {css:{x:0, y:0, opacity: 1}, ease: Power2.easeInOutExpo},
                            0.1
                        );
                    }
                });
                tm.to($('.nav__btn-toggle'), 0.4, {
                    css: {opacity:1}, ease: Power1.easeOut, delay: 0.4
                });
                allPagesAnimateIn();
            }
        });
    };

    return {
        init: init,
    }
});